"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames_1 = require("../../../utilities/classNames");
var formCore_1 = require("../formCore");
var validationWrapper_1 = require("../validationWrapper");
var options_1 = require("./options");
var SelectInput = /** @class */ (function (_super) {
    tslib_1.__extends(SelectInput, _super);
    function SelectInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.change = function (e) {
            var _a = _this.props, change = _a.change, onChange = _a.onChange, options = _a.options;
            if (change) {
                change(options[e.target.selectedIndex - 1]);
            }
            if (onChange) {
                onChange(e);
            }
        };
        return _this;
    }
    SelectInput.prototype.focus = function () {
        if (this.select) {
            this.select.focus();
        }
    };
    SelectInput.prototype.blur = function () {
        if (this.select) {
            this.select.blur();
        }
    };
    SelectInput.prototype.render = function () {
        var _this = this;
        var validationMessage = formCore_1.DataValidationMessage.get(this.props);
        var _a = this.props, options = _a.options, change = _a.change, onChange = _a.onChange, optionLabel = _a.optionLabel, validationMode = _a.validationMode, enableOptionLabel = _a.enableOptionLabel, attrs = tslib_1.__rest(_a, ["options", "change", "onChange", "optionLabel", "validationMode", "enableOptionLabel"]);
        var classes = classNames_1.ClassHelpers.classNames("armstrong-input", "select-input", this.props.className, {
            "show-validation": (validationMode !== "none" && validationMessage),
        });
        return (React.createElement("div", { className: classes, title: validationMessage },
            React.createElement("select", tslib_1.__assign({}, attrs, { ref: function (r) { return _this.select = r; }, onChange: this.change }), options_1.buildOptions(optionLabel, options, function (o) { return o.id; }, function (o) { return o.name; }, !!enableOptionLabel)),
            React.createElement(validationWrapper_1.ValidationLabel, { message: validationMessage, mode: validationMode })));
    };
    SelectInput.defaultProps = {
        optionLabel: "[Select]",
        validationMode: "none",
    };
    return SelectInput;
}(React.Component));
exports.SelectInput = SelectInput;
